import PageHeader from '@components/common/PageHeader';
import ServiceOption from '@components/instructor/ServiceOption';
import React from 'react';

const InstructorServices: React.FC = () => {
  return (
    <div className='w-full h-full overflow-auto'>
      <PageHeader text='INSTRUCTOR SERVICES'></PageHeader>
      <div className='mt-20 flex flex-col mx-8 w-auto max-w-xl lg:w-1/2'>
        <ServiceOption text='Account Information' route='/account' />
        <ServiceOption text='Request Volunteer Hours' route='/comingsoon' />
        <ServiceOption text='How to Use This Portal' route='/comingsoon' />
      </div>
    </div>
  );
};

export default InstructorServices;
